/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

export const options =
    [
        { value: 'nl', label: 'NL' },
        { value: 'en', label: 'ENG' },
    ];
